import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, finalize, tap, throwError } from 'rxjs';
import { DataCoreService } from '../../../services/data-core.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../services/app-settings.service';
import {DlistDto, GetDlist_Request, GetDlist_Response} from "@dabnet-kamu/libs/ui";

@Injectable({
  providedIn: 'root'
})
export class CtlBysSurecService {

  public birim!: number;
  public isReadOnly!: boolean;
  public isBindCheck!: boolean;
  public _gridControlsList: BehaviorSubject<DlistDto | null> = new BehaviorSubject(null);
    public gridControlsList$ = this._gridControlsList.asObservable();
     constructor(private dataCoreService: DataCoreService,private _httpClient:HttpClient) {}


  setParams(birim: number, isReadOnly:boolean, isBindCheck:boolean){
    this.birim = birim;
    this.isReadOnly = isReadOnly;
    this.isBindCheck = isBindCheck;
  }

  getData(code?: number, birim?: number, control?:any , baseEntity?: string, isSetData?: boolean) {
     let dataSource: any;
     let tableName = "";
      if (this.isBindCheck && this.isReadOnly){
      tableName = control.showEntity?control.showEntity:control.dlistMetadata.baseEntity;
      dataSource = this.dataCoreService.getOData(tableName);
    } 
    else{
      dataSource = this.dataCoreService.getOData(baseEntity);
    }
    dataSource.select([]);
    const filterArr = [];
    if (birim) filterArr.push(['BirimKod', '=', birim]);
    if (code) filterArr.push(['Kod', '=', code]);
     dataSource.filter(filterArr);
    return dataSource;
  }}
